import Attendance from './Attendance';

export default Attendance;
